import { AssignmentListItemSkeleton } from '@module/assignment-components';

const SKELETON_ROW_COUNT = 5;

export const AssignmentListSkeleton = () => (
  <>
    {Array.from({ length: SKELETON_ROW_COUNT }, (_, index) => (
      <AssignmentListItemSkeleton key={index} />
    ))}
  </>
);
